<template>
  <qx-card-form title="银行信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="receiver" slot-scope="prop">
        <ChooseReceiver
          :isRadio="true"
          v-model="prop.form.receiver"
          @change="handleReceiverChange"
        />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import ChooseReceiver from 'components/choose/receiver';
export default {
  components: {
    ChooseReceiver,
  },
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '收款人',
            value: 'receiver',
            slot: true,
            default: {},
          },
          {
            label: '收款手机',
            value: 'receiverPhone',
            type: 'input',
            disabled: true,
          },
          {
            label: '银行户名',
            value: 'accName',
            type: 'input',
            disabled: true,
          },
          {
            label: '银行账号',
            value: 'accNo',
            type: 'input',
            disabled: true,
          },
          {
            label: '开户银行',
            value: 'bankName',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          receiver: [
            { required: true, message: '请选择收款人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    handleReceiverChange (receiver) { // 收款人变化
      this.$refs.baseForm.setVal('receiverPhone', receiver.receiverPhone); // 收款手机
      this.$refs.baseForm.setVal('accName', receiver.acctName); // 银行户名
      this.$refs.baseForm.setVal('accNo', receiver.acctNo); // 银行账号
      this.$refs.baseForm.setVal('bankName', receiver.bankName); // 开户银行
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.receUserType = formData.receiver.userType; // 收款方类型
        formData.receiverMan = formData.receiver.receiverName; // 收款人
        formData.receUserId = formData.receiver.userId; // 收款方ID
        delete formData.receiver;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    init (data = {}) {
      data.receiver = {
        userType: data.receUserType, // 收款方类型
        receiverName: data.receiverMan || data.borrowName, // 收款人
        userId: data.receUserId || data.borrowUserId, // 收款方ID
        receiverPhone: data.receiverPhone || data.borrowPhone, // 收款手机
        acctName: data.accName, // 银行户名
        accNo: data.acctNo, // 银行账号
        bankName: data.bankName, // 开户银行
      };
      data.receiverPhone = data.receiverPhone || data.borrowPhone;
      this.$refs.baseForm.setVal('form', data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
